/**
 * AnnouncementBar — persistent royal-blue strip pinned at the top of the
 * viewport with an infinite right-to-left marquee. Sits directly above the
 * sticky navbar.
 */

const PHRASE_A = "The X-Factor Marketing Agency";
const PHRASE_B = "Results that Resonate";

// Build the exact "A | B | A | B | ..." stream as specified.
const STREAM = Array(10).fill([PHRASE_A, PHRASE_B].join(" | ")).join(" | ") + " | ";

export default function AnnouncementBar() {
  return (
    <div
      data-testid="announcement-bar"
      className="fixed top-0 left-0 right-0 z-[60] flex items-center overflow-hidden"
      style={{ height: "34px", backgroundColor: "#2770FD" }}
    >
      <div
        className="marquee-track flex w-max items-center"
        style={{ animationDuration: "80s" }}
      >
        <span className="px-2 text-white text-[12px] sm:text-[13px] font-semibold uppercase tracking-[0.18em] whitespace-nowrap">
          {STREAM}
        </span>
        <span
          aria-hidden
          className="px-2 text-white text-[12px] sm:text-[13px] font-semibold uppercase tracking-[0.18em] whitespace-nowrap"
        >
          {STREAM}
        </span>
      </div>
    </div>
  );
}
